import React, {useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../api/store";
import { getDoctorData } from "../api/slices/DoctorTableSlice";
import { getIllness } from "../api/illness/IllnessSlice";
import DoctorIllnessSelector from "../components/Doctor/DoctorIllnessSelector";



const BookAppointmentNew2: React.FC = () => {
  // State for illness selection
  const dispatch = useDispatch<AppDispatch>();
  const { doctorTable ,doctorTableLoading } = useSelector(
    (state: RootState) => state.doctorTable
  );
   const { illnesses, illnessLoading } = useSelector(
    (state: RootState) => state.illness
  );
  useEffect(() => {
      dispatch(getDoctorData());
      dispatch(getIllness());
    }, [dispatch]);

  return (
    <div className="w-full max-w-4xl mx-auto px-2 sm:px-4">
      <AnimatePresence mode="wait">
        <motion.div
            key="illness-view"
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            transition={{ duration: 0.2 }}
            className="h-full mt-3"
          >
           <DoctorIllnessSelector doctors={doctorTable} illnesses={illnesses} doctorTableLoading={doctorTableLoading} illnessLoading={illnessLoading}/>
          </motion.div>
       
      </AnimatePresence>
    </div>
  );
};

export default BookAppointmentNew2;